<div id="entire_home_component">
    <div *ngIf="loading" class="loader">
        <app-loader></app-loader>
    </div>
    
    <div class="cookies_disabled" *ngIf="cookies_disabled">
        <div class="cookie_modal_container col-mob-11">
            <div class="image">
                <img src="../../../assets/app/cookies.png" alt="">
            </div>
            <div class="message">
                <h1>You must enable cookies</h1>
                <p>Inkingi fashion design shop uses browser cookies and yours have been disabled please enable them to continue shopping.</p>
                <button (click)="enableBrowserCookies()">Edit settings by <strong>&nbsp;ALT + F&nbsp;</strong> then <strong>&nbsp;S&nbsp;</strong></button>
            </div>
        </div>
    </div>

    <div *ngIf="isSuccess || hasErrorAlert" class="success_message">
        <div class="msg_box" [ngClass]="{'isFailed': hasErrorAlert}">
            <p *ngIf="isSuccess">{{ successMsg }}</p>
            <p *ngIf="hasErrorAlert">{{ hasErrorMsg }}</p>
            <svg *ngIf="isSuccess" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z" fill="rgba(255,255,255,1)"/></svg>
            <svg *ngIf="hasErrorAlert" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z" fill="rgba(255,255,255,1)"/></svg>
        </div>
    </div>

    <div class="video_viewer" *ngIf="viewingVidMedia">
        <svg (click)="closeAllMediaView()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="#ffffff" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"/></svg>
        <video [src]="currentVideoBeingViewed" muted autoplay controls></video>
        <div class="videos">
            <video *ngFor="let vid of currentCustomizations.videoShots; let i = index " [src]="vid" (click)="viewVidMedia(vid)"></video>
        </div>
    </div>

    <div class="banner_section">
        <!-- <div (click)="viewVidMedia(currentCustomizations.videoShots[0])" class="play_button">
            <p>PLAY</p>
        </div> -->
        <swiper [config]="config">
            <div class="swiper-wrapper">
                <img class="swiper-slide" *ngFor="let img of currentCustomizations.mainSlideImages; let i = index" [src]="img" alt=""/>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(255,255,255,1)"/></svg></div>
            <div class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(255,255,255,1)"/></svg></div>
        </swiper>
    </div>

    <div class="inkingi_identifier">
        <h1>Maison Inkingi</h1>
        <!-- <p>From Ink We Make</p> -->
    </div>

    <div class="inkingi_collections">
        <div>

            <div class="inkingi_video_container col-mob-12">
                <div class="play_btns" [ngClass]="{'paused_video': !playingVideo}">
                    <div class="play_circle">
                        <svg *ngIf="playingVideo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M6 5h2v14H6V5zm10 0h2v14h-2V5z" fill="rgba(255,255,255,1)"/></svg>
                        <svg *ngIf="!playingVideo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.394 12L10 7.737v8.526L16.394 12zm2.982.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" fill="rgba(255,255,255,1)"/></svg>
                    </div>
                </div>
                <video id="video_back" (click)="pausePlay()" [src]="currentVideoBeingViewed"></video>
                <video id="video" (click)="pausePlay()" [src]="currentVideoBeingViewed"></video>
                <!-- <video src="https://youtu.be/7Ng2MqsVfoE" muted autoplay controls></video> -->
                <!-- <iframe width="1350" height="530" src="https://www.youtube.com/embed/7Ng2MqsVfoE?controls=0&mute=1&showinfo=0&rel=0&autoplay=1&loop=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
            </div>

            <div class="inkingi_container_collections col-mob-12" *ngIf="len > 0">
                <div class="inkingi_collection" (click)="getThisCollection(collectionsArr[0].collectionName, collectionsArr[0].collectionDeleted)">
                    <div id="caption" class="captions">
                        <h3>{{ collectionsArr[0].collectionName }}</h3>
                    </div>
                    <img class="col-mob-12" [src]="collectionsArr[0].mainCollectionImage" alt="" />
                </div>
            </div>  

        </div>
    </div>

    <div class="best_of_our_products">
        <div class="header">
            <h4>Latest products</h4>
            <h1>{{ currentCustomizations.dashboardProductsTitle }}</h1>
            <p>{{ currentCustomizations.dashboardProductsDescription }}</p>
        </div>

        <div class="card_group_recent_products" (mouseover)="showBtnFunc()" >

            <div *ngIf="loadingFewProducts" class="loading_products">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="48" height="48"
                viewBox="0 0 172 172"
                style=" fill:#000000;"><g transform="translate(5.59,5.59) scale(0.935,0.935)"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="none" stroke-linecap="butt" stroke-linejoin="none" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><g stroke="#f5f5f5" stroke-width="12" stroke-linejoin="round"><path d="M86,157.66667c-39.517,0 -71.66667,-32.14967 -71.66667,-71.66667c0,-39.517 32.14967,-71.66667 71.66667,-71.66667c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667zM86,28.66667c-31.61217,0 -57.33333,25.72117 -57.33333,57.33333c0,31.61217 25.72117,57.33333 57.33333,57.33333c31.61217,0 57.33333,-25.72117 57.33333,-57.33333c0,-31.61217 -25.72117,-57.33333 -57.33333,-57.33333z" fill="#cfd8dc"></path><path d="M86,157.66667c-39.517,0 -71.66667,-32.14967 -71.66667,-71.66667h14.33333c0,31.61217 25.72117,57.33333 57.33333,57.33333c31.61217,0 57.33333,-25.72117 57.33333,-57.33333c0,-31.61217 -25.72117,-57.33333 -57.33333,-57.33333v-14.33333c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667z" fill="#333333"></path></g><path d="M0,172v-172h172v172z" fill="none" stroke="none" stroke-width="1" stroke-linejoin="miter"></path><g stroke="none" stroke-width="1" stroke-linejoin="miter"><path d="M86,157.66667c-39.517,0 -71.66667,-32.14967 -71.66667,-71.66667c0,-39.517 32.14967,-71.66667 71.66667,-71.66667c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667zM86,28.66667c-31.61217,0 -57.33333,25.72117 -57.33333,57.33333c0,31.61217 25.72117,57.33333 57.33333,57.33333c31.61217,0 57.33333,-25.72117 57.33333,-57.33333c0,-31.61217 -25.72117,-57.33333 -57.33333,-57.33333z" fill="#cfd8dc"></path><path d="M86,157.66667c-39.517,0 -71.66667,-32.14967 -71.66667,-71.66667h14.33333c0,31.61217 25.72117,57.33333 57.33333,57.33333c31.61217,0 57.33333,-25.72117 57.33333,-57.33333c0,-31.61217 -25.72117,-57.33333 -57.33333,-57.33333v-14.33333c39.517,0 71.66667,32.14967 71.66667,71.66667c0,39.517 -32.14967,71.66667 -71.66667,71.66667z" fill="#333333"></path></g><path d="" fill="none" stroke="none" stroke-width="1" stroke-linejoin="miter"></path></g></g></svg>
            </div>

            <swiper [config]="config_2" *ngIf="!loadingFewProducts" class="carousel_2_container hidden_mob">
                <div class="swiper-wrapper">
                    <img class="swiper-slide slide_2_imgs" *ngFor="let img of fewProducts; let i = index" [src]="img.productMainImage" alt="" (click)="viewSlideProduct(img._id)"/>
                </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(255,255,255,1)"/></svg></div>
                <div class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(255,255,255,1)"/></svg></div>
            </swiper>
            
            <div class="mobile_slideshow_container">
                <swiper [config]="config" *ngIf="!loadingFewProducts" class="hidden_desk mobile_response_swiper">
                    <div class="swiper-wrapper">
                        <img class="swiper-slide slide_2_imgs" *ngFor="let img of fewProducts; let i = index" [src]="img.productMainImage" alt="" (click)="viewSlideProduct(img._id)"/>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(255,255,255,1)"/></svg></div>
                    <div class="swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="38" height="38"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(255,255,255,1)"/></svg></div>
                </swiper>
            </div>

        </div>
    </div>

    <div class="buy_a_product col-12 col-tab-12 col-large-12 col-mob-12">
        <div class="buy_a_product_content">
            <div class="circle_cover1"></div>
            <div class="circle_cover2"></div>
            <div class="buy_a_product_details col-mob-12">
                <h1>Designs Blowing Your Mind? Let's Ship It To You.</h1>
                <p>Inkingi fashion design has made it as simple as possible for its clients to get the best services by providing <br>
                    an easy way to search, pay and ship their blowing millions of design made by us to their homes just on the mobile devices. 
                </p>
            </div>
            <div class="buy_a_product_link col-mob-12">
                <button>
                    <a routerLink="shop" class="hide_only_on_tab">
                        Shop here now
                    </a>
                    <a routerLink="shop" class="show_only_on_tab">
                        Shop now
                    </a>
                </button>
            </div>
        </div>
    </div>

    <div class="our_location">
        <div class="header">
            <h4>Location details</h4>
            <h1>Get To Know Our Location</h1>
            <p>Want to visit and have more personal business with us, just visit our headquarters in Kigali - Rwanda.</p>
        </div>
        <div class="location_map">
            <div class="map">
                <iframe
                    frameborder="0" style="border:0"
                    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyC1qW9oGtlv7XCaAIlr1YgYhkQ1C_2Tcgc&maptype=satellite&q=Kimihurura,+Kigali" allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>
</div>